import React from "react";
import styles from "./Footer.module.scss";
import FooterCTA from "./FooterCTA";
import FooterNavigation from "./FooterNavigation";
import FooterBottom from "./FooterBottom";

const Footer: React.FC = () => (
  <footer className={styles["o-footer"]} role="contentinfo">
    <FooterCTA />
    <FooterNavigation />
    <FooterBottom />
  </footer>
);

export default Footer;
